// Date display helpers. All backend dates are ISO strings (YYYY-MM-DD or full ISO).
// We ALWAYS display dates in DD-MM-YYYY format across the app (Argentine convention).

// Extract YYYY-MM-DD from any ISO datetime string.
const isoDatePart = (s) => (typeof s === "string" ? s.slice(0, 10) : "");

// "2025-03-14" -> "14-03-2025". Returns "-" for empty/invalid input.
export function formatDMY(iso) {
  const d = isoDatePart(iso);
  if (!d || d.length < 10) return "-";
  const [y, m, day] = d.split("-");
  if (!y || !m || !day) return "-";
  return `${day}-${m}-${y}`;
}

// "2025-03-14T12:34:56Z" -> "14-03-2025 12:34". Returns "-" for empty/invalid input.
export function formatDMYTime(iso) {
  if (typeof iso !== "string" || iso.length < 10) return "-";
  const datePart = formatDMY(iso);
  if (datePart === "-") return "-";
  // Try to extract HH:MM from the time portion.
  const timeMatch = iso.slice(10).match(/(\d{2}):(\d{2})/);
  return timeMatch ? `${datePart} ${timeMatch[1]}:${timeMatch[2]}` : datePart;
}
